import { AfterViewChecked, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Component({
  selector: 'ipm-common-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit, OnChanges {
  @Input() isAddContainer: false;
  @Input() id: string = "";
  slideConfig: any = {};
  @Input()  imageArray: Array<any> = [];
  bannerList: Array<any> = [];
  @Output() clickSliderBanner: EventEmitter<any> = new EventEmitter();
  @ViewChild('slickModal', { static: false }) slickModal: SlickCarouselComponent;
  constructor(private route: Router,
  private browserService: BrowserStorageService) {}
  ngOnInit(): void { 
    this.setBannerConfig();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageArray']) {
        this.bannerList = this.imageArray;
        this.setBannerConfig();
         setTimeout(() => {
          if (this.slickModal) {
            this.slickModal.unslick();
            this.slickModal.initSlick();
          }
        }, 100);
        
    }
  }
 
  onSliderBannerClick(routerName: string) {
    // if (this.browserService.getSaleActiveFlag()) {
      if (routerName) {
        this.route.navigate([routerName]);
      }
    // }
  }

  setBannerConfig() {
   this.slideConfig = { 
    centerMode: true,
    dots: false,
    arrows: false,
    autoWidth: true,
    infinite: true,
    centerPadding: '60px',
    autoplay: true,
    slidesToShow: 1, 
    slidesToScroll: 1,
    touchThreshold: 8,
    swipe: true,
    touchMove: true,
    accessibility: true,
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 991,
      settings: {
        arrows: false,
        infinite: true,
        autoplay: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 700,
      settings: {
        arrows: false,
        infinite: true,
        autoplay: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        autoplay: true,
        infinite: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
    ]
  };
  }
}
